// @flow
import { isString } from 'lodash';

function getCapitalLetters(firstName: string, lastName: string): string {
  return (
    (firstName ? firstName.charAt(0).toUpperCase() : '') +
    (lastName ? lastName.charAt(0).toUpperCase() : '')
  );
}

function getFirstWord(str: ?string) {
  return isString(str) ? str.replace(/\s.*/, '') : '';
}

function getValidString(str: ?string) {
  return isString(str) ? str.trim() : '';
}

function truncate(str: string, characters: ?number, preserveWords: boolean = false): string {
  const strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    const length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }
  return strTrimed;
}

function titleCase(str: string) {
  return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

function camelCasify(text: string): string {
  return text
    .split(' ')
    .map((word, i) => {
      if (i > 0) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word.toLowerCase();
    })
    .join('');
}

const upperCaseLetterToInt = (letter: string) => letter.charCodeAt(0) - 64;

function snakeToCamel(s: string) {
  return s.replace(/(_\w)/g, function(match) {
    return match.toUpperCase().substr(1);
  });
}

export {
  getCapitalLetters,
  getFirstWord,
  getValidString,
  titleCase,
  truncate,
  camelCasify,
  upperCaseLetterToInt,
  snakeToCamel,
};
